import { BlockQuery, DatoAssetQuery } from '@queries/datoCMS';
import { gql } from 'graphql-request';
import { z } from 'zod';

export const AssetBlockQuery = new BlockQuery(
	'asset',
	gql`
		... on AssetRecord {
			_modelApiKey
			media {
				${DatoAssetQuery}
			}
			fixedAspectRatio
		}
	`,
	z.object({
		_modelApiKey: z.enum(['asset']),
		media: DatoAssetQuery.validation,
		fixedAspectRatio: z.boolean()
	})
);

export type AssetBlock = z.infer<typeof AssetBlockQuery.validation>;
